import { useContext } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import DisclaimerDialog from './DisclaimerDialog';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
const ProtectedRoute = () => {
  //const { logout } = useContext(AuthContext);
  const currentLocation = useLocation(); // ✅ safer name
  const {
    isAuthenticated,
    profileUpdated,
    disclaimerAccepted,
    setDisclaimerAccepted,
    isLoggingOut, 
    logout,
  } = useContext(AuthContext);

  const handleAgree = async () => {
    try {
      await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/disclaimer/accept`, {}, {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      });
      setDisclaimerAccepted(true);
    } catch (error) {
      console.error('Error accepting disclaimer:', error);
    }
  };

  const handleLogout = () => {
    // localStorage.removeItem('token');
    // window.location.href = "/login";
    logout();
    window.location.href = "/2.0/login";
  };

  //if (loading || isAuthenticated === null || disclaimerAccepted === null) return null;
 
  //if (isLoggingOut) return <Navigate to="/" />;
  if (!isAuthenticated && !isLoggingOut) {
    return <Navigate to="/2.0/login" replace state={{ from: currentLocation }} />;
  }

  if (localStorage.getItem('isEnterprise') === 'yes') {
    const enterpriseAllowedPaths = [
      '/2.0',
      '/2.0/udyogconnect-home',
      '/2.0/about',
      '/2.0/enterprise-management',
      '/2.0/updatepassword',
    ];

    if (!enterpriseAllowedPaths.includes(currentLocation.pathname)) {
      return <Navigate to="/2.0/enterprise-management" replace />;
    }
  }

  //if (!isAuthenticated) return <Navigate to="/login" />;
  //if (!isAuthenticated) return <Navigate to="/login" />;
  if (!disclaimerAccepted) {
    return <DisclaimerDialog open={true} onAgree={handleAgree} onLogout={handleLogout} />;
  }

  if (!profileUpdated && currentLocation.pathname !== '/2.0/profile-update') {
    return <Navigate to="/2.0/profile-update" replace />;
  }
  return <Outlet />;
};

export default ProtectedRoute;
